

class Auth{
  TokenKey = "Client-Token"
  UserKey = "Client-User"
   constructor(){

  }
  getToken() {
    return localStorage.getItem(this.TokenKey);
  }
  setToken(token) {
    return localStorage.setItem(this.TokenKey, token);
  }
  removeToken() {
    return localStorage.removeItem(this.TokenKey);
  }
  getUser() {
    return JSON.parse(localStorage.getItem(this.UserKey));
  }
  getUserBy(key) {
    return JSON.parse(localStorage.getItem(this.UserKey))[key];
  }
  setUser(user) {
    return localStorage.setItem(this.UserKey, user);
  }
}

export default new Auth()